module.exports = __webpack_public_path__ + "img/macWallpaper.512a6843.webp";